import { Button } from '@mui/material';
import Box from '@mui/material/Box';
// import Switch from '@mui/material/Switch';
// import { axiosPost } from '@root/services/axios/axiosPost';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import NotificationPanelSkleton from './Skleton';
import NotificationMap from './NotificationMapping';
import NotificationMonitor from '../../../../assets/svg/icons/notifications-monitor.svg';
import { fetchNotificationlistData } from './action';
import './style.scss';
import { useTheme } from '@root/context/ThemeContext';
import { CommonToggleSwitch } from '@root/utilities/common';

// const CustomSwitch = styled(props => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(
//   ({ theme }) => ({
//     width: 42,
//     height: 20,
//     padding: 0,
//     '& .MuiSwitch-switchBase': {
//       padding: 0,
//       margin: 2,
//       '&.Mui-checked': {
//         transform: 'translateX(22px)',
//         color: '#fff',
//         '& + .MuiSwitch-track': {
//           backgroundColor: '#194BFB',
//           opacity: 1,
//           border: 0,
//         },
//         '&.Mui-disabled + .MuiSwitch-track': {
//           opacity: 0.5,
//         },
//       },
//       '&.Mui-focusVisible .MuiSwitch-thumb': {
//         color: '#194BFB',
//         border: '6px solid #fff',
//       },
//       '&.Mui-disabled .MuiSwitch-thumb': {
//         color: theme.palette.grey[100],
//       },
//       '&.Mui-disabled + .MuiSwitch-track': {
//         opacity: 0.7,
//       },
//     },
//     '& .MuiSwitch-thumb': {
//       boxSizing: 'border-box',
//       width: 16,
//       height: 16,
//     },
//     '& .MuiSwitch-track': {
//       borderRadius: 26 / 2,
//       backgroundColor: '#CBD5E0',
//       opacity: 1,
//     },
//     '& .MuiTypography-root': {
//       color: '#484D56',
//       fontFamily: 'Manrope',
//       fontSize: '16px',
//     },
//   }),
// );

function NotificationsPanel({
  isOpen,
  onClose,
  todayNotificationsList,
  setTodayNotificationsList,
  setShowNotificationsPanel,
}) {
  const dispatch = useDispatch();
  const { isDarkMode } = useTheme();
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);

  const handleOutsideClick = useCallback(
    e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setShowNotificationsPanel(false);
      }
    },
    [setShowNotificationsPanel],
  );
  const [scrollPosition, setScrollPosition] = useState(0);
  const notificationList = useSelector(state => state.notification.notification_list.results);
  const notificationCount = useSelector(state => state.notification.notification_list.unread_count);
  const { page, prevPage, hasMore } = useSelector(state => state.notification.notification_list);

  console.log(hasMore, prevPage, page, 'notificationList');

  const todaysDate = moment().format('YYYYY-DD-MM');
  const yesterdayDate = moment().subtract(1, 'days').format('YYYYY-DD-MM');
  const [onlyUnread, setOnlyUnread] = useState(false);

  useEffect(() => {
    const container = document.querySelector('.infinite-scroll-component');

    const handleScroll = () => {
      if (container) {
        setScrollPosition(container.scrollTop);
      }
    };

    if (container) {
      container.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [handleOutsideClick]);

  const handleShowUnread = () => {
    dispatch({
      type: 'RESET_BELL_PAGE',
    });
    setOnlyUnread(prev => !prev);
    fetchNotificationsData(true, !onlyUnread);
  };

  const history = useHistory();

  const [yesterdayNotificationsList, setYesterdayNotificationsList] = useState([]);
  const [pastNotificationsList, setPastNotificationsList] = useState([]);

  useEffect(() => {
    if (isEmpty(notificationList)) {
      setTodayNotificationsList([]);
      setYesterdayNotificationsList([]);
      setPastNotificationsList([]);
    } else {
      [...new Set([notificationList])]?.[0]?.forEach(item => {
        // todays notification
        let date = moment(item.created_time).format('YYYYY-DD-MM');
        if (date === todaysDate) {
          setTodayNotificationsList(prev => {
            const isExist = prev.find(e => e.id === item.id);
            if (!isExist) {
              return [...prev, item];
            }
            return prev;
          });
        } else if (yesterdayDate === date) {
          //yesterday notification
          setYesterdayNotificationsList(prev => {
            const isExist = prev.find(e => e.id === item.id);
            if (!isExist) {
              return [...prev, item];
            }
            return prev;
          });
        } else {
          //past notification
          setPastNotificationsList(prev => {
            const isExist = prev.find(e => e.id === item.id);
            if (!isExist) {
              return [...prev, item];
            }
            return prev;
          });
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificationList, todaysDate, yesterdayDate]);

  const isFetchingRef = useRef(false);

  const fetchNotificationsData = async (firstLoad, onlyUnread) => {
    // Prevent multiple simultaneous requests
    if (isFetchingRef.current) return;

    if (firstLoad) {
      isFetchingRef.current = true;
      setLoading(true);
      const res = await fetchNotificationlistData(dispatch, 1, onlyUnread, false);
      if (res) {
        setLoading(false);
      }
      isFetchingRef.current = false;
    } else if (hasMore && prevPage !== page) {
      isFetchingRef.current = true;
      await fetchNotificationlistData(dispatch, page, onlyUnread, false);
      isFetchingRef.current = false;
    }
  };
  const handleReadAll = useCallback(async () => {
    // const res = await axiosHelper.axiosPost(
    //   'notification_bellicon_list',
    //   { data: { status: onlyUnread ? false : 'All', mark_all_read: true } },
    //   false,
    // );
    const res = await fetchNotificationlistData(dispatch, 1, onlyUnread, true);
    console.log(res, 'res');
  }, [dispatch, onlyUnread]);

  return (
    <>
      <div className={`NotificationsPanelBackdrop ${isOpen ? 'Visible' : ''}`} onClick={onClose}></div>
      <div ref={ref} className={`NotificationsPanelContainer ${isOpen ? 'Visible' : ''}`}>
        <Box className="NotificationsPanel__Header">
          <h3>Alerts</h3>
          <Box className="NotificationsPanel__HeaderSubtitle">Show only unread</Box>{' '}
          <CommonToggleSwitch sx={{ marginLeft: '9px' }} onChange={handleShowUnread} />
        </Box>

        <Box
          height="200px"
          flexGrow={1}
          flexShrink={1}
          className="CustomScrollbar NotificationsPanel__NotificationList">
          {loading && notificationList.length === 0 ? (
            <div style={{ height: '100%' }}>
              <NotificationPanelSkleton />
            </div>
          ) : notificationList.length === 0 ? (
            <>
              <div
                style={{
                  textAlign: 'center',
                  fontFamily: 'Manrope',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                }}>
                {onlyUnread ? (
                  <b>There are no unread alerts</b>
                ) : (
                  <div className="NotificationPanel__PastAreaContent">
                    <img src={NotificationMonitor} alt="notification-monitor" />
                    <b style={{ marginTop: '8px' }} className="txt">
                      There are no alerts{' '}
                    </b>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <InfiniteScroll
                dataLength={notificationList.length}
                next={() => fetchNotificationsData(false, onlyUnread)}
                hasMore={hasMore}
                className="CustomScrollbar"
                height={440}
                initialScrollY={0}
                loader={
                  <div style={{ height: '100%' }}>
                    <NotificationPanelSkleton />
                  </div>
                }
                endMessage={
                  <div className="NotificationPanel__PastAreaContent">
                    <img src={NotificationMonitor} alt="notification-monitor" />
                    <p className="txt">That’s all your alerts from the last 20 days. </p>
                  </div>
                }>
                <>
                  <div className={`NotificationsPanel__NewContainer ${scrollPosition >= 100 ? 'sticky' : ''}`}>
                    <div style={{ flexGrow: '1' }} />

                    {notificationCount > 0 && (
                      <Box
                        onClick={() => handleReadAll()}
                        // onClick={() => setIsYesterdayAllRead(!isYesterdayAllRead)}
                        style={{
                          borderRight: '1px solid #d1d2d5',
                          paddingRight: '8px',
                          marginRight: '8px',
                          cursor: 'pointer',
                          lineHeight: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                        }}>
                        <Button
                          style={{
                            fontSize: '12px',
                            textTransform: 'none',
                            // borderRight: '1px solid #000000',
                            paddingRight: '8px',
                            marginRight: '8px',
                            cursor: 'pointer',
                            lineHeight: 'normal',
                            display: 'flex',
                            alignItems: 'center',
                            color: isDarkMode ? 'var(--text-secondary)' : '#194bfb',
                            fontFamily: 'Manrope',
                            padding: '0px 5px',
                            height: '20px',
                          }}>
                          <svg
                            style={{ marginRight: 2 }}
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M1.75 9.75L4.25 12.25M7.75 8.25L10.25 5.75M5.75 9.75L8.25 12.25L14.25 5.75"
                              stroke={isDarkMode ? 'var(--text-secondary)' : '#194bfb'}
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          Mark all as read
                        </Button>
                      </Box>
                    )}

                    <Box
                      onClick={() => {
                        history.push('/notifications/logs');
                        onClose();
                      }}
                      style={{ cursor: 'pointer' }}>
                      <Button
                        style={{
                          fontSize: '12px',
                          textTransform: 'none',
                          // borderRight: '1px solid #000000',
                          paddingRight: '8px',
                          marginRight: '8px',
                          cursor: 'pointer',
                          lineHeight: 'normal',
                          display: 'flex',
                          alignItems: 'center',
                          color: isDarkMode ? 'var(--text-secondary)' : '#194bfb',
                          fontFamily: 'Manrope',
                          padding: '0px 5px',
                          height: '20px',
                        }}>
                        View all alerts
                      </Button>
                    </Box>
                  </div>
                  {todayNotificationsList.length > 0 ? (
                    <>
                      <div className="NotificationPanel__MainItemWrapper">
                        <div
                          style={{
                            color: isDarkMode ? 'var(--text-primary)' : '#1A202C',
                            fontSize: '14px',
                            fontWeight: 600,
                            fontFamily: 'Manrope',
                          }}>
                          Today
                        </div>
                        {todayNotificationsList.map((notification, idx) => (
                          <NotificationMap
                            notification={notification}
                            key={idx}
                            // onClick={() => history.push(`/notifications/logs?id=${notification.id}`)}
                          />
                        ))}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </>

                <>
                  {yesterdayNotificationsList.length > 0 ? (
                    <>
                      <div className="NotificationPanel__MainItemWrapper">
                        <div
                          style={{
                            color: isDarkMode ? 'var(--text-primary)' : '#1A202C',
                            fontSize: '14px',
                            fontWeight: 600,
                            fontFamily: 'Manrope',
                          }}>
                          Yesterday
                        </div>
                        {yesterdayNotificationsList.map((notification, idx) => (
                          <NotificationMap
                            notification={notification}
                            key={idx}
                            onClick={() => history.push(`/notifications/logs?id=${notification.id}`)}
                          />
                        ))}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </>

                <>
                  {pastNotificationsList.length > 0 ? (
                    <>
                      <div className="NotificationPanel__MainItemWrapper">
                        <div
                          style={{
                            color: isDarkMode ? 'var(--text-primary)' : '#1A202C',
                            fontSize: '14px',
                            fontWeight: 600,
                            fontFamily: 'Manrope',
                          }}>
                          Older
                        </div>
                        {pastNotificationsList.map((notification, idx) => (
                          <NotificationMap
                            notification={notification}
                            key={idx}
                            onClick={() => history.push(`/notifications/logs?id=${notification.id}`)}
                          />
                        ))}
                      </div>
                    </>
                  ) : (
                    <>
                      {/* <div className={`NotificationsPanel__NewContainer ${scrollPosition >= 200 ? 'sticky' : ''}`}>
                        <div style={{ color: '#1A202C' }}>Past</div>
                        <div style={{ flexGrow: '1' }} />
                        {isPastAllRead && (
                          <Box
                            // onClick={() => handleReadAll()}
                            onClick={() => setIsPastAllRead(!isPastAllRead)}
                            style={{
                              borderRight: '1px solid #000000',
                              paddingRight: '8px',
                              marginRight: '8px',
                              cursor: 'pointer',
                              lineHeight: 'normal',
                              display: 'flex',
                              alignItems: 'center',
                            }}>
                            <svg
                              style={{ marginRight: 2 }}
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M1.75 9.75L4.25 12.25M7.75 8.25L10.25 5.75M5.75 9.75L8.25 12.25L14.25 5.75"
                                stroke="#194BFB"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            <span style={{fontSize:'12px'}}>Mark all as read</span>
                          </Box>
                        )}
                        <Box
                          onClick={() => {
                            history.push('/notifications/logs');
                            onClose();
                          }}
                          style={{ cursor: 'pointer' }}>
                          <span style={{fontSize:'12px'}}>View all alerts</span>
                        </Box>
                      </div>
                      <div className="NotificationPanel__MainItemWrapper">
                        <div
                          style={{ textDecoration: 'none', cursor: 'pointer' }}
                          className="NotificationPanel__Item__Wrapper">
                          <Box className="CustomScrollbar NotificationPanel__Item">
                            <div className="NotificationPanel__ItemStatusIndicatorWrapper">
                              <div className={`NotificationPanel__ItemStatusIndicator Low__Status`}></div>
                            </div>
                            <div className="NotificationPanel__ItemInfoWrapper">
                              <div className="NotificationPanel__ItemEventTimeWrapper">
                                <div className="NotificationPanel__Event">Test</div>
                                <div className="NotificationPanel__DateTime">2 day ago</div>
                              </div>
                              <div className="NotificationPanel__Status">Ok</div>
                              <div className="NotificationPanel__Feature">
                                Affected Resources: <span>38</span>
                              </div>
                              <div className="NotificationPanel__EnvironmnetID">
                                Environment ID: <span>88923749</span>
                              </div>
                            </div>
                          </Box>
                        </div>
                        <div
                          style={{ textDecoration: 'none', cursor: 'pointer' }}
                          className="NotificationPanel__Item__Wrapper">
                          <Box className="CustomScrollbar NotificationPanel__Item">
                            <div className="NotificationPanel__ItemStatusIndicatorWrapper">
                              <div className={`NotificationPanel__ItemStatusIndicator Low__Status`}></div>
                            </div>
                            <div className="NotificationPanel__ItemInfoWrapper">
                              <div className="NotificationPanel__ItemEventTimeWrapper">
                                <div className="NotificationPanel__Event">Test</div>
                                <div className="NotificationPanel__DateTime">2 day ago</div>
                              </div>
                              <div className="NotificationPanel__Status">Ok</div>
                              <div className="NotificationPanel__Feature">
                                Affected Resources: <span>38</span>
                              </div>
                              <div className="NotificationPanel__EnvironmnetID">
                                Environment ID: <span>88923749</span>
                              </div>
                            </div>
                          </Box>
                        </div>
                        <div
                          style={{ textDecoration: 'none', cursor: 'pointer' }}
                          className="NotificationPanel__Item__Wrapper">
                          <Box className="CustomScrollbar NotificationPanel__Item">
                            <div className="NotificationPanel__ItemStatusIndicatorWrapper">
                              <div className={`NotificationPanel__ItemStatusIndicator Low__Status`}></div>
                            </div>
                            <div className="NotificationPanel__ItemInfoWrapper">
                              <div className="NotificationPanel__ItemEventTimeWrapper">
                                <div className="NotificationPanel__Event">Test</div>
                                <div className="NotificationPanel__DateTime">2 day ago</div>
                              </div>
                              <div className="NotificationPanel__Status">Ok</div>
                              <div className="NotificationPanel__Feature">
                                Affected Resources: <span>38</span>
                              </div>
                              <div className="NotificationPanel__EnvironmnetID">
                                Environment ID: <span>88923749</span>
                              </div>
                            </div>
                          </Box>
                        </div>
                        <div
                          style={{ textDecoration: 'none', cursor: 'pointer' }}
                          className="NotificationPanel__Item__Wrapper">
                          <Box className="CustomScrollbar NotificationPanel__Item">
                            <div className="NotificationPanel__ItemStatusIndicatorWrapper">
                              <div className={`NotificationPanel__ItemStatusIndicator Low__Status`}></div>
                            </div>
                            <div className="NotificationPanel__ItemInfoWrapper">
                              <div className="NotificationPanel__ItemEventTimeWrapper">
                                <div className="NotificationPanel__Event">Test</div>
                                <div className="NotificationPanel__DateTime">2 day ago</div>
                              </div>
                              <div className="NotificationPanel__Status">Ok</div>
                              <div className="NotificationPanel__Feature">
                                Affected Resources: <span>38</span>
                              </div>
                              <div className="NotificationPanel__EnvironmnetID">
                                Environment ID: <span>88923749</span>
                              </div>
                            </div>
                          </Box>
                        </div>
                        <div
                          style={{ textDecoration: 'none', cursor: 'pointer' }}
                          className="NotificationPanel__Item__Wrapper">
                          <Box className="CustomScrollbar NotificationPanel__Item">
                            <div className="NotificationPanel__ItemStatusIndicatorWrapper">
                              <div className={`NotificationPanel__ItemStatusIndicator Low__Status`}></div>
                            </div>
                            <div className="NotificationPanel__ItemInfoWrapper">
                              <div className="NotificationPanel__ItemEventTimeWrapper">
                                <div className="NotificationPanel__Event">Test</div>
                                <div className="NotificationPanel__DateTime">2 day ago</div>
                              </div>
                              <div className="NotificationPanel__Status">Ok</div>
                              <div className="NotificationPanel__Feature">
                                Affected Resources: <span>38</span>
                              </div>
                              <div className="NotificationPanel__EnvironmnetID">
                                Environment ID: <span>88923749</span>
                              </div>
                            </div>
                          </Box>
                        </div>
                        <div
                          style={{ textDecoration: 'none', cursor: 'pointer' }}
                          className="NotificationPanel__Item__Wrapper">
                          <Box className="CustomScrollbar NotificationPanel__Item">
                            <div className="NotificationPanel__ItemStatusIndicatorWrapper">
                              <div className={`NotificationPanel__ItemStatusIndicator Low__Status`}></div>
                            </div>
                            <div className="NotificationPanel__ItemInfoWrapper">
                              <div className="NotificationPanel__ItemEventTimeWrapper">
                                <div className="NotificationPanel__Event">Test</div>
                                <div className="NotificationPanel__DateTime">2 day ago</div>
                              </div>
                              <div className="NotificationPanel__Status">Ok</div>
                              <div className="NotificationPanel__Feature">
                                Affected Resources: <span>38</span>
                              </div>
                              <div className="NotificationPanel__EnvironmnetID">
                                Environment ID: <span>88923749</span>
                              </div>
                            </div>
                          </Box>
                        </div>
                      </div> */}
                    </>
                  )}
                </>
              </InfiniteScroll>
              {/* )} */}
            </>
          )}
        </Box>

        {/* <Box className="NotificationsPanel__Footer">
          <Box className="NotificationsPanel__FooterLinkTitle">Show only unread</Box>
        </Box> */}
      </div>
    </>
  );
}

export default NotificationsPanel;
